














import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { RoomMember } from '@/class/roomMember'
import Ready from './Ready/Ready.vue'
import Play from './Play/Play.vue'
import Gameover from './Gameover/Gameover.vue'
import GameLogCutIn from './GameLogCutin/GameLogCutIn.vue'
import ChatWindow from './Chat/ChatWindow.vue'

@Component({
  components: {
    Ready,
    Play,
    Gameover,
    GameLogCutIn,
    ChatWindow,
  }
})

export default class GameView extends Vue {
  @Prop() game!: Game;
  @Prop() playerId!: string;
  @Prop() memberSelf?: RoomMember;
  @Prop() isGallary!: boolean;
  @Prop() userInterfaceType!: 'A' | 'B';

  created () {
    this.$watch('playerSelfRoleId', () => {
      window.scrollTo({ top: 0 })
    })
  }

  get playerSelf () {
    if (!this.playerId) return null

    return this.game.gamePlayerOf[this.playerId]
  }

  get playerSelfRoleId () {
    return this.playerSelf ? this.playerSelf.roleId : null
  }

  get showsChat () {
    if (this.game.isGameover) {
      return true
    }

    if (this.isGallary) {
      return true
    }

    if (!this.playerSelf) {
      return true
    }

    if (this.playerSelf.isDead) {
      return true
    }

    return false
  }
}
